export default "__VITE_ASSET__34523f3d__"